import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import ReactQuill from "react-quill";

const TemplateFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  // const [entities, setEntities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [wildcards, setWildcards] = useState([]);
  const quill = React.useRef(false)

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().templateId) || (entity === 'template' && id)) {
      apiCall('patch', '/api/v2/document-template/' + id, data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderTemplateList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/document-template', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderTemplateList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/docs/template/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  const toolbarOptions = {
    container: [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      ['image', 'formula'],
      [{'align': []}],

      [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'color': []}, {'background': []}],
      ['clean']
    ]
  }

  useEffect(() => {
    // apiCall('get', '/api/v2/dictionary/document-related-entity')
    //   .then(response => {
    //     setEntities(response.data.data)
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    //   })
    apiCall('get', '/api/v2/document-category')
      .then(response => {
        setCategories(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().templateId) || (entity === 'template' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/document-template/' + (window.App.urlVars().templateId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    if (formData.related_entity) {
      apiCall('get', '/api/v2/document-template/variables/' + formData.related_entity.split('\\').pop().replace(/^./, str => str.toLowerCase()))
        .then(response => {
          setWildcards(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [formData.related_entity])

  return (
    <div className={"template-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="related_entity" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="related_entity"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRelatedEntity')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions([
                       {"key": "Munkavállaló", "value": "App\\Entity\\Employee"},
                       {"key": "Szerződés", "value": "App\\Entity\\Contract"},
                       {"key": "Projekt", "value": "App\\Entity\\Project"}
                     ], "key")}
                               id={"related_entity"}
                               optionValue={"value"}
                               optionLabel={"key"}
                               emptyMessage={t('noEntityYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   related_entity: e.value
                                 })
                               }}
                               value={Number(window.App.urlVars().relatedEntityId) || formData.related_entity?.id || formData.related_entity}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="document_category" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="document_category"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCategory')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(categories, "name")}
                               id={"document_category"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCategoryYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   document_category: e.value
                                 })
                               }}
                               value={Number(window.App.urlVars().categoryId) || formData.document_category?.id || formData.document_category}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-8"}>
              <div className="p-field p-fluid">
                <label>{props.t('fieldContent')}</label>
                <div id={"editor-container"}>
                  <ReactQuill style={{height: '620px'}}
                              value={formData.body}
                              modules={{toolbar: toolbarOptions}}
                              id={"body"}
                              ref={quill}
                              onChange={(e) => {
                                setFormData({...formData, body: e})
                              }}/>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label>{props.t('fieldReplacementExpressions')}</label>
                {wildcards && wildcards[0] &&
                  <>
                    {wildcards.map((wildcard, index) => {
                      let text = wildcard.key
                      return (
                        <>
                              <span className={"p-d-block p-mb-1"} style={{cursor: 'pointer'}}
                                    onClick={() => {
                                      var selection = quill.current.getEditor().getSelection(true);
                                      quill.current.getEditor().insertText(selection.index, text);
                                    }}>
                                <i className={"pi pi-link"}></i> {wildcard.label}
                              </span>
                        </>
                      )
                    })}
                  </>
                }
              </div>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'template' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(TemplateFormComponent);
